import SecretsCoverups from './SecretsCoverups'

export default SecretsCoverups
// eslint-disable-next-line import/export
export * from './SecretsCoverups'
